import * as yup from 'yup';
import {ObjectSchema} from 'yup';
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import React from "react";

interface FormData {
    firstName: string,
    lastName: string | undefined,
    age: number,
    website: string | undefined,
}

const SignupSchema: ObjectSchema<FormData> = yup.object().shape({
    firstName: yup.string().required().test(
        'lunghezza',
        'almeno 10 caratteri',
        (value) => {
            return (value && value.length >= 10) ? true : false;
        },
    ).test(
        'spazio',
        'almeno uno spazio',
        (value) => {
            return (value && value.indexOf(' ') > 0) ? true : false;
        },
    ),
    lastName: yup.string().required(),
    age: yup.number().required().positive().integer(),
    website: yup.string().url()
});

interface FormData2 extends yup.InferType<typeof SignupSchema> {
    // using interface instead of type generally gives nicer editor feedback
}

const a: FormData2 = {} as FormData2;

export default function Accesso() {
    //https://www.react-hook-form.com/api/useform/#resolver
    const {
        register,
        handleSubmit,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(SignupSchema)
    });
    const [isShow, setIsShow] = React.useState(false);

    const onSubmit = (data: any) => {
        console.info(data);
    };

    const onError = (errors: any) => {
        console.error(errors);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)}>
            {isShow ? (
                <>
                    <div>
                        <label>First Name</label>
                        <input type="text" {...register("firstName")} />
                        {errors.firstName && <p>{errors.firstName.message}</p>}
                    </div>
                    <div style={{marginBottom: 10}}>
                        <label>Last Name</label>
                        <input type="text" {...register("lastName")} />
                        {errors.lastName && <p>{errors.lastName.message}</p>}
                    </div>
                </>
            ) : (
                <>
                    <div>
                        <label>Age</label>
                        <input type="text" {...register("age")} />
                        {errors.age && <p>{errors.age.message}</p>}
                    </div>
                    <div>
                        <label>Website</label>
                        <input type="text" {...register("website")} />
                        {errors.website && <p>{errors.website.message}</p>}
                    </div>
                </>
            )}
            <button onClick={() => setIsShow((p) => !p)}>toggle</button>
            <input type="submit"/>
        </form>
    );
}
